import { render, staticRenderFns } from "./OrganismWorkload.vue?vue&type=template&id=2647bb50&scoped=true&"
import script from "./OrganismWorkload.vue?vue&type=script&lang=js&"
export * from "./OrganismWorkload.vue?vue&type=script&lang=js&"
import style0 from "./OrganismWorkload.vue?vue&type=style&index=0&id=2647bb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647bb50",
  null
  
)

export default component.exports